// extracted by mini-css-extract-plugin
module.exports = {"submittedMsg":"style_submittedMsg__BJaoE","link":"style_link__oRq_f"};